
const APIConstant = {
  DEPLOY_ENV: 'prod',
  // translator and clientAdmin added in s3
  // user:"andover@ceauthor.com",
  ManagerConfigs:[{configname:"Identifying and Addressing Forced Labour - French Canadian",_id:"66a8bdfce0884c2b1a287d26"},{configname:"Identifying and Addressing Forced Labour - LA Spanish",_id:"66c320670859d13c1abb6af8"}],

  getBaseUrlPath: () => {
    //const APP_ROOT_URL = '/ceauthoradmin/build'; // When we know the direcotry and pacakge json is './
    //const currentPath = document.location.pathname || APP_ROOT_URL;
    //const startOfAppBase = currentPath.indexOf(APP_ROOT_URL);

    const APP_ROOT_URL = '';
    const currentPath = document.location.pathname;
    const startOfAppBase = currentPath.indexOf(APP_ROOT_URL); 
    let base = currentPath;

    if (startOfAppBase < 0 ) {
      base = currentPath.substr(0, startOfAppBase);
    }

    base = base + APP_ROOT_URL//urlJoin(base, APP_ROOT_URL);

    return base;
  },

  getUrl : (location) => {
    switch(location)  {
      
      case 'capi':
      return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.CURATOR_API_DESTINATION_PROD : APIConstant.CURATOR_API_DESTINATION_STGN;

      case 'ceauthor':
      return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.CEAUTHOR_PROD_URL : APIConstant.CEAUTHOR_STGN_URL;
      case 'ceauthor_v30':
        return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.CEAUTHOR_PROD_URL_v30 : APIConstant.CEAUTHOR_STGN_URL;
      case 'api':
      return  APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.API_DESTINATION_PROD : APIConstant.API_DESTINATION_STGN;

      case 'player':
      return  APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.COURSE_PLAYER_PROD_URL : APIConstant.COURSE_PLAYER_STGN_URL;

      case 'lms':
        return  APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.LMS_API_DESTINATION_PROD : APIConstant.LMS_API_DESTINATION_STGN;

        case 'clientid':
          return  APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.PROD_CURATOR_CLIENTID : APIConstant.STAGE_CURATOR_CLIENTID;    
          
        case 'configstructure':
          return  APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.PROD_CONFIG_STRUCTURE : APIConstant.STAGE_CONFIG_STRUCTURE;
          case 'ceapi':
          return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.API_NEW_DESTINATION_PROD : APIConstant.API_DESTINATION_STGN;  
        case 'betacache':
          return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.API_NEW_DESTINATION_PROD : APIConstant.API_NEW_DESTINATION_PROD;  
        case 'courseconfigapi':
          return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.API_COURSECONFIG_PROD : APIConstant.API_DESTINATION_STGN;  
        case 'storeapi':
          return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.STOREFRONT_API_DESTINATION_PROD : APIConstant.STOREFRONT_API_DESTINATION_STGN;  
        case 'custore':
          return  APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.API_CUSTORE_PROD : APIConstant.API_CUSTORE_STGN
          case 'fixedauth':
            return APIConstant.DEPLOY_ENV === 'prod' ? APIConstant.LIVE_AUTH : APIConstant.STG_AUTH;
        case 's3':
            return APIConstant.S3_DESTINATION
    }
  },

  // SDX sync (CEA -> SDX staging) is only offered for this client
  SDX_CLIENT_ID: 81,

  ENCRYPT_IV : '0123456789123456',
  ENCRYPT_KEY :  "HG58YZ3CR9HG58YZ3CR93CR9",
  ENCRYPT_CODE: '66821-YN-sgnirpSagotaraS-yawdaorB-264',

  LIVE_AUTH:"eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI0MjA3NTo0MTphZG1pbl9jZWF1dGhvckBjZWF1dGhvci5jb206YWRtaW5fY2VhdXRob3JAY2VhdXRob3IuY29tIiwiZXhwIjoxNzIyNjk4NjEyfQ.YFyWkq0Z9bUj09plf1aiDSurgu-V24qPwWjN0yGTebXKlaOF0jICDJd1YwhnqAdy23KMYcNnQDjfWN-SzAO_QQ",
  STG_AUTH:"eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI0OTI1MjoyMzc6a2FyYV9jZWF1dGhvckBjb250ZW50ZW5hYmxlcnMuY29tOmthcmFfY2VhdXRob3JAY29udGVudGVuYWJsZXJzLmNvbSIsImV4cCI6MTczMjc4MTk3OX0.CiNGjNclS1VJc77nSIEl40KPuF5XBdqhPNzk2Xef-P2-fzbgTf_-Se9cKmKO3guT_uRE3rZ7cMHbKyPFOS25Hg",
  // curator goes through appproxy in both environments
  CURATOR_API_DESTINATION_PROD : 'https://appproxy.contentenablers.com/curator/index.php/api/',
  CURATOR_API_DESTINATION_STGN : 'https://appproxy.contentenablers.com/curator/index.php/api/',

  CEAUTHOR_PROD_URL : 'https://ceauthor.contentenablers.com/launcher.html',
  CEAUTHOR_PROD_URL_v20 : 'https://resources.contentenablers.com/platform/players/v_20/cea_launcher.html',
  CEAUTHOR_PROD_URL_v30:'https://resources.contentenablers.com/platform/players/v_30/launcher.html',
  CEAUTHOR_STGN_URL : 'https://contentenablers.dev/launcher.html',

  COURSE_PLAYER_PROD_URL : 'https://resources.contentenablers.com/platform/ceacourseplayer.html',
  COURSE_PLAYER_STGN_URL : 'https://resources.contentenablers.com/platform/clauncher_staging.html',

  LMS_API_DESTINATION_PROD: '//lms.contentenablers.com/storefront/',
  LMS_API_DESTINATION_STGN: '//learner.contentenablers.com/storefront/',

  API_DESTINATION: 'https://api-cea.contentenablers.com/api/',
  S3_DESTINATION:'https://s3.us-east-1.amazonaws.com/resources.contentenablers.com/',

  API_DESTINATION_PROD: 'https://api-cea.contentenablers.com/api/',
  API_DESTINATION_STGN: 'https://tradecompliance.training/xapice/api/',

  API_CUSTORE_PROD:"https://storefront.contentenablers.com/storefront2020/index.php/api/lmscoursemap/",
  API_CUSTORE_STGN:"https://appproxy.contentenablers.com/curator/index.php/api/courses/",

  API_NEW_DESTINATION_PROD:'https://beta-cached.contentenablers.com/api/',
  // API_NEW_DESTINATION_STGN:'https://tradecompliance.training/xapice/api/',
  
  STOREFRONT_API_DESTINATION_PROD:'https://storefront.contentenablers.com/storefront2020/index.php/api/',
  STOREFRONT_API_DESTINATION_STGN:'//appproxy.contentenablers.com/storefront2020/index.php/api/',
  
  API_COURSECONFIG_PROD:'https://api.ceauthor.com/api/',
  // API_COURSECONFIG_STGN:'https://tradecompliance.training/xapice/api/',

  ADMIN_TAGS_URL:'https://webapi.contentenablers.com/api/',

  STAGE_CURATOR_CLIENTID : "41",
  PROD_CURATOR_CLIENTID : "41",
  PROD_CONFIG_STRUCTURE : 'https://api-cea.contentenablers.com/api/courses/getcoursestructure/',
  STAGE_CONFIG_STRUCTURE : 'https://tradecompliance.training/xapice/api/courseconfig/getcourseconfigstructure/',

  ROLES: {
    "1": { id: 1, name: "Approve Manager" },
    "2": { id: 2, name: "SME" },
    "3": { id: 3, name: "Tech Support" },
    "4": { id: 4, name: "Asset Manager" },
    "5": { id: 5, name: "Client" }
  },
  CATEGORY: {
    "1": { id: 1, name: "Import" },
    "2": { id: 2, name: "Export" },
    "3": { id: 3, name: "Sanctions & Embargoes" },
    "4": { id: 4, name: "Miscellaneous" },
    "5": { id: 5, name: "Security & Trade" },
    "6": { id: 6, name: "Corruption & Antiboycott" }
  },

  STATUS_LRN_AIDS : { 
    '-1' : { id: -1, status: "Not-started" },
    '0' : { id: 0, status: "Canceled" },
    '1' : { id: 1, status: "Approved" },
    '2' : { id: 2, status: "In-Progress" },
    '3' : { id: 3, status: "Under review" },
},

listIterator: (list, cnt, parent, topics, flat) => {
  list?.forEach(item => {
      cnt++;
      let dep = parent + '.' + cnt;
      //BAD !!
      delete item?.level;
      delete item?.status;
      item.nodeId = dep?.substr(1);
      item.p = 10
      item.topic = item?.id;
      flat[item?.nodeId] = item;

      /** 
      * Added for curtor Archived Video flow  
      * In response topic content will be empty so added 
      */
      if (item?.lrncontent === null && !item?.children) {
          item.lrncontent = item.lrncontent
      }
      if (item.children) {
          item.open = true; // open accordion status
          APIConstant.listIterator(item?.children, 0, dep, topics, flat)
      }
  })
},

getFilePath : (src)=>{
  return  (src && src?.includes(`http`)) ? src : `https://www.contentenablers.com${src}`;
},

  CLIENT_ROLE_ID: 5,


  ACL_RESPONSE: {
    "status": 1,
    "_id": "6270adcbca076d36eee9e9e2",
    "features": [
      {
        "_id": "6270adcbca076d36eee9e9e3",
        "id": 1,
        "name": "Learning Elements",
        "permissions": [
          {
            "_id": "6270adcbca076d36eee9e9e4",
            "id": 1,
            "name": "Add"
          },
          {
            "_id": "6270adcbca076d36eee9e9e5",
            "id": 2,
            "name": "Edit"
          },
          {
            "_id": "6270adcbca076d36eee9e9e6",
            "id": 3,
            "name": "Delete"
          }
        ]
      },
      {
        "_id": "6270adcbca076d36eee9e9e7",
        "id": 2,
        "name": "Comments",
        "permissions": [
          {
            "_id": "6270adcbca076d36eee9e9e8",
            "id": 1,
            "name": "Add"
          },
          {
            "_id": "6270adcbca076d36eee9e9e9",
            "id": 2,
            "name": "Edit"
          },
          {
            "_id": "6270adcbca076d36eee9e9ea",
            "id": 3,
            "name": "Delete"
          }
        ]
      },
      {
        "_id": "6270adcbca076d36eee9e9eb",
        "id": 3,
        "name": "Topic Templates",
        "permissions": [
          {
            "_id": "6270adcbca076d36eee9e9ec",
            "id": 1,
            "name": "Create"
          },
          {
            "_id": "6270adcbca076d36eee9e9ed",
            "id": 2,
            "name": "Apply"
          },
          {
            "_id": "6270adcbca076d36eee9e9ee",
            "id": 3,
            "name": "Delete"
          }
        ]
      },
      {
        "_id": "6270adcbca076d36eee9e9ef",
        "id": 4,
        "name": "Asset Library",
        "permissions": [
          {
            "_id": "6270adcbca076d36eee9e9f0",
            "id": 1,
            "name": "Add"
          },
          {
            "_id": "6270adcbca076d36eee9e9f1",
            "id": 2,
            "name": "Edit"
          },
          {
            "_id": "6270adcbca076d36eee9e9f2",
            "id": 3,
            "name": "Delete"
          }
        ]
      }
    ],
    "roles": [
      {
        "_id": "6270adcbca076d36eee9e9f3",
        "id": 0,
        "name": "Admin"
      },
      {
        "_id": "6270adcbca076d36eee9e9f4",
        "id": 1,
        "name": "Approve Manager"
      },
      {
        "_id": "6270adcbca076d36eee9e9f5",
        "id": 2,
        "name": "SME"
      },
      {
        "_id": "6270adcbca076d36eee9e9f6",
        "id": 3,
        "name": "Tech Support"
      },
      {
        "_id": "6270adcbca076d36eee9e9f7",
        "id": 4,
        "name": "Asset Manager"
      },
      {
        "_id": "6270adcbca076d36eee9e9f8",
        "id": 5,
        "name": "Client"
      }
    ],
    "acl": [
      {
        "role": 0,
        "access": [
          {
            "fid": 1,
            "grants": [
              1,
              2,
              3
            ]
          },
          {
            "fid": 2,
            "grants": [
              1,
              2,
              3
            ]
          },
          {
            "fid": 3,
            "grants": [
              1,
              2,
              3
            ]
          },
          {
            "fid": 4,
            "grants": [
              1,
              2,
              3
            ]
          }
        ]
      },
      {
        "role": 1,
        "access": [
          {
            "fid": 1,
            "grants": [
              1,
              2,
              3
            ]
          }
        ]
      },
      {
        "role": 2,
        "access": []
      },
      {
        "role": 3,
        "access": []
      },
      {
        "role": 4,
        "access": []
      },
      {
        "role": 5,
        "access": []
      }
    ],
    "createdAt": "2022-05-03T04:21:31.262Z",
    "updatedAt": "2022-05-03T04:21:31.262Z",
    "__v": 0
  },
//   AIzaSyDmbD-YSaYDWn52ikorTdtcmvPzg_Pd5Fo
  GOOGLE_MAPS_API : "AIzaSyAE2WznR_Vrb9MTBk31tg_SM38zGSCsUSU",
  COUNTRY_CODE:{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia (Plurinational State of)","BQ":"Bonaire, Sint Eustatius and Saba","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","CV":"Cabo Verde","KH":"Cambodia","CM":"Cameroon","CA":"Canada","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo (Democratic Republic of the)","CK":"Cook Islands","CR":"Costa Rica","HR":"Croatia","CU":"Cuba","CW":"Curaçao","CY":"Cyprus","CZ":"Czech Republic","CI":"Côte d'Ivoire","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","SZ":"Eswatini","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran (Islamic Republic of)","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Korea (Democratic People's Republic of)","KR":"Korea (Republic of)","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia (Federated States of)","MD":"Moldova (Republic of)","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":"North Macedonia","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","RE":"Réunion","BL":"Saint Barthélemy","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","MF":"Saint Martin (French part)","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten (Dutch part)","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan, Province of China","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom of Great Britain and Northern Ireland","UM":"United States Minor Outlying Islands","US":"United States of America","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela (Bolivarian Republic of)","VN":"Viet Nam","VG":"Virgin Islands (British)","VI":"Virgin Islands (U.S.)","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"},
  MAPSTYLE : [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.business",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ],
}

export default APIConstant